import { api } from "@/services";
import { useState } from "react";
import { useIsomorphicLayoutEffect } from "../Custom";

function useModelsContents(slug: string = null) {
  const [Response, setResponse] = useState(null);
  const [Loading, setLoading] = useState(true);
  const [Error, setError] = useState(null);

  useIsomorphicLayoutEffect(() => {
    const Controller = new AbortController();

    const MakeRequest = async () => {
      try {
        const resp = await api.get(`Contents/GetBySlug?slugs=${slug ?? "menu-modelos-LingLong"}`, {
          signal: Controller.signal
        });
        if (resp.data) {
          setResponse(resp.data);
        } else {
          setError("Nenhum conteúdo encontrado");
        }
      } catch (Err) {
        setError(Err.message);
      } finally {
        setLoading(false);
      }
    };

    MakeRequest();

    return () => Controller.abort();
  }, []);

  return [Response, Loading, Error];
}

export { useModelsContents };
